import React, { Component } from 'react';
import ListProject from "./ListProject";
class Project extends Component {
	constructor(props) {
        super(props);
        this.state = {
            titleProject: [
                {
                    id: 1,
                    title: 'Case Studies & Results',
                    }
            ],
        }
    }
    render() {
        return (
            <section className="flat-row flat-owl-stage" style={{ width: '100vw', marginLeft: 'calc(50% - 50vw)' }}>
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="title-section center modern-section-title">
                                <span className="modern-title-kicker">Impact</span>
                            {
                                this.state.titleProject.map(data =>(
                                    <h2 key={data.id}>Case Studies <span>& Results</span></h2>
                                ))
                            }
                                <p className="sub-title-section">Practical outcomes from analytics, MERL, and advisory engagements.</p>
                            </div>
                        </div>
                    </div>
                    <ListProject />
                </div>
            </section>
        );
    }
}

export default Project;
